import type { ApiNode } from '@goalbuddy/client';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { DestinationPicker } from './destination-picker';
import { Dialog } from './ui';

/** Global "Move to…" dialog. Open with `openMove(id)`. */
export function MoveDialog() {
  const [id, setId] = useState<number | null>(null);
  const [node, setNode] = useState<ApiNode | null>(null);
  useEffect(() => {
    const onOpen = (e: Event) => setId((e as CustomEvent<{ id: number }>).detail.id);
    window.addEventListener('gb:move', onOpen);
    return () => window.removeEventListener('gb:move', onOpen);
  }, []);
  useEffect(() => {
    if (id === null) return setNode(null);
    api.node(id).then(setNode, () => setId(null));
  }, [id]);
  const move = useMutation({
    mutationFn: (parent: number | null) => api.moveNode(id!, parent),
    onSuccess: () => {
      toast.success(`Moved: ${node?.title}`);
      setId(null);
    },
  });
  return (
    <Dialog
      open={id !== null}
      onOpenChange={(o) => !o && setId(null)}
      title={node ? `Move “${node.title}”` : 'Move'}
    >
      {node && <DestinationPicker node={node} onPick={(p) => move.mutate(p)} />}
    </Dialog>
  );
}
